import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

@Pipe({name: 'sanitizer'})
export class DomSanitizerPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	public transform = (url: string): SafeUrl => this.sanitizer.bypassSecurityTrustUrl(url);
}
